import Mock from 'mockjs';
import './account';
import './menu';
import './video';
import './comment';

Mock.setup({
  timeout: '200-600',
});
